export default "__VITE_ASSET__BpEN$r4W__"